module.exports = __webpack_public_path__ + "img/home-bg3-m.22434ba0.png";